import { object, string } from "yup";
import { PASSWORD_RULE } from "./signupValidationSchema";

export const loginFormSchema = object().shape({
    login_type: string()
        .oneOf(["email", "phone"])
        .defined()
        .when("$configObj", ([config], schema) => {
            if (config && config.enableSwitch) {
                return schema.required();
            }

            return schema.notRequired();
        }),
    password: PASSWORD_RULE,
    email: string().when("login_type", ([login_type], schema, options) => {
        if (login_type === "email") {
            return schema.required(options.context.configObj.t("validation_err_required"));
        }
        return schema;
    }),
    phone: string()
        .trim()
        .when("login_type", ([login_type], schema, options) => {
            if (login_type === "phone") {
                return schema.required(options.context.configObj.t("validation_err_required"));
            }
            return schema;
        }),
});
